import React,{useState} from 'react'
import "./Dice.css"
function Dice() {
const [die1num,setdie1Num] = useState("6")

    const [die2num, setdie2Num] = useState("6")
const [flag, setflag] = useState(false)
const handleDice= () =>{
    setdie1Num(Math.floor((Math.random() * 6) + 1))
    setdie2Num(Math.floor((Math.random() * 6) + 1))
    setflag(!flag)
}

    return (
        <div className="diceApp">
            <div className="dice">
            <div className={flag ? "aniOut" :"output"}>
                {die1num}
                </div>
                <div className={flag ? "aniOut" : "output"}>
                    {die2num}
                </div>
            </div>
            <button onClick={handleDice}>
                Roll
            </button>
        </div>
    )
}

export default Dice
